import { TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import React from 'react';

interface Props<T> {
  multiple?: boolean;
  options: T[];
  getOptionSelected?: (option: T, value: T) => boolean;
  optionLabelGetter: (option: T) => string;
  placeholder: string;
  value: T | T[] | null;
  defaultValue?: T | T[] | null;
  disabled?: boolean;
  disableClearable?: boolean;
  onChange: (event: React.ChangeEvent<any>, newValue: any) => void;
}

function MedAutocomplete<T>(props: Props<T>) {
  const {
    multiple,
    getOptionSelected,
    options,
    optionLabelGetter,
    value,
    onChange,
    placeholder,
    defaultValue,
    disabled,
    disableClearable,
  } = props;

  return (
    <Autocomplete
      multiple={multiple}
      disabled={disabled}
      options={options}
      value={value}
      defaultValue={defaultValue}
      onChange={onChange}
      getOptionSelected={getOptionSelected}
      getOptionLabel={optionLabelGetter}
      disableClearable={disableClearable}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          margin="dense"
          placeholder={placeholder}
        />
      )}
    />
  );
}

export default MedAutocomplete;
